import {CasinoAction, CasinoActionTypes, GamesByPage, PageStudio} from "./CasinoActions";
import {CasinoGameInfo, CasinoSortedLobby, Jackpot} from "../http/protocol";
import {UserAction, UserActionTypes} from "../user/UserActions";

export enum ListMode {
    THUMBNAIL, DESCRIPTION
}

export enum CasinoStatus {
    LOADING, DONE, ERROR, NONE
}
export interface CasinoState {
   lobby?: CasinoSortedLobby;
   studiosInPage? : PageStudio[];
   selectedTabId?: number;
   selectedPageId?: number;
   previousSelectedPageId?: number;
   selectedCategoryId?: number;
   showAllStudios?: boolean;
   status?: CasinoStatus;
   mode?: ListMode;
   searchValue?: string;
   recentlyPlayedGamesByPage? : GamesByPage[];
   favouriteGamesByPage? : GamesByPage[];
   jackpots? : Jackpot[];
   selectedGames? : CasinoGameInfo[];
   pageSelected?: boolean;
   loadingSelectedGames? : boolean;
   bannerHeight? : number;
   isFilterActiveBonusGames?: boolean;
}

const initialState : CasinoState = { loadingSelectedGames : false, selectedGames : [], status: CasinoStatus.NONE, studiosInPage : [], jackpots : [],  showAllStudios : false, mode: ListMode.THUMBNAIL, searchValue : "", recentlyPlayedGamesByPage : [], favouriteGamesByPage : [], isFilterActiveBonusGames : false};

export function casinoReducer(state: CasinoState = initialState, action : CasinoAction|UserAction ) {

    switch (action.type) {
        case UserActionTypes.LOGIN_RESPONSE:
            return {...state, selectedStudios: []};
        case CasinoActionTypes.SET_SELECTED_GAMES:
            return {...state, selectedGames : action.games, loadingSelectedGames : false };
        case CasinoActionTypes.SET_CASINO_TOP_BANNER_HEIGHT:
            return {...state, bannerHeight : action.bannerHeight};
        case CasinoActionTypes.SELECT_FILTER:
            return {...state, selectedCategoryId: undefined, loadingSelectedGames : true }
        case CasinoActionTypes.JACKPOTS_RESPONSE:
            return {...state, jackpots : action.jackpots }
        case CasinoActionTypes.CLEAR_FILTERS:
            return {...state, loadingSelectedGames : false, selectedGames : [], searchValue : "", selectedCategoryId : undefined};
        case CasinoActionTypes.SHOW_ALL_STUDIOS:
            return {...state, showAllStudios : action.show};
        case CasinoActionTypes.SET_FAVOURITE_GAMES:
            return {...state,  favouriteGamesByPage : action.gamesByPage};
        case CasinoActionTypes.SET_PLAYED_GAMES:
            return {...state,  recentlyPlayedGamesByPage : action.gamesByPage };
        case CasinoActionTypes.GAMES_RESPONSE:
            let selectedTab = 0;
            let page = action.lobby.pages?.find(p => p.defaultPage);
            if(page?.tabs && page.tabs.length >0) {
                selectedTab = page.tabs[0].id ?? 0;
            }
            return {...state, lobby : action.lobby, status: CasinoStatus.DONE, selectedTabId : selectedTab, favouriteGamesByPage : action.favouritesByPage, recentlyPlayedGamesByPage : action.recentlyPlayedByPage };
        case CasinoActionTypes.GAMES_REQUEST:
            return {...state, status : CasinoStatus.LOADING};
        case CasinoActionTypes.GAMES_ERROR:
            return {...state, status : CasinoStatus.ERROR };
        case CasinoActionTypes.SELECT_TAB:
            return {...state, selectedTabId : action.tabId, searchValue : "", selectedPageId : action.pageId, previousSelectedPageId: state.selectedPageId, selectedCategoryId : undefined, pageSelected : true};
        case CasinoActionTypes.SELECT_CATEGORY:
            return {...state, selectedCategoryId : action.catId, pageSelected : true};
        case CasinoActionTypes.SELECT_LIST_MODE:
            return {...state, mode : action.mode};
        case CasinoActionTypes.UPDATE_SEARCH_VALUE:
            return {...state, searchValue : action.value, selectedCategoryId : undefined};
        case CasinoActionTypes.SET_FILTER_ACTIVE_BONUS_GAMES:
            return {...state, isFilterActiveBonusGames: action.isFilterActiveBonusGames};
        default:
            return state;
    }
}
